import React, { useContext, useEffect, useState } from "react";
import MenuButton from "../MenuButton/MenuButton";
import UserServices from "../../UserServices/UserServices";
import { NoteState } from "../../context/notes/NoteState";
import moment from "moment";
import jsPDF from "jspdf";
import "jspdf-autotable";

export default function PhysioGX() {
  const { state } = useContext(NoteState);
  const { branch_id } = state;

  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState([]);
  const [search, setSearch] = useState("");

  useEffect(() => {
    fetchRows();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [branch_id]);

  const fetchRows = async (override = {}) => {
    if (!branch_id) return;
    setLoading(true);
    try {
      const res = await UserServices.getPhysioGxClients({
        branch_id,
        search: (override.search ?? search) || undefined,
      });
      if (res.status === 200 && res.data.status) {
        setRows(res.data.data || []);
      }
    } catch (err) {
      console.log(err);
      setRows([]);
    }
    setLoading(false);
  };

  const handleExcel = async () => {
    try {
      const res = await UserServices.exportPhysioGxClients({
        branch_id,
        search: search || undefined,
      });
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `Physio_GX_${moment().format("YYYY-MM-DD")}.xlsx`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.log(err);
      alert("Failed to export GX data");
    }
  };

  const handlePdf = () => {
    try {
      const doc = new jsPDF("l", "mm", "a4");
      doc.setFontSize(16);
      doc.text("Physio GX Clients", 14, 16);
      doc.autoTable({
        startY: 22,
        head: [["S.No", "Date", "Name", "Diagnosis", "Region", "Session"]],
        body: rows.map((r, i) => [
          i + 1,
          r.record_date || "",
          r.name || "",
          r.diagnosis || "",
          r.region || "",
          r.session_recommended || "",
        ]),
        headStyles: { fillColor: [128, 0, 255], textColor: 255 },
        styles: { fontSize: 8 },
      });
      doc.save(`Physio_GX_${moment().format("YYYY-MM-DD")}.pdf`);
    } catch (err) {
      console.log(err);
      alert("Failed to generate PDF");
    }
  };

  return (
    <div className="site-main-design">
      <MenuButton />
      <div className="container-fluid">
        <div className="page-heading d-flex justify-content-between align-items-center mb-3">
          <h3 className="mb-0">
            <i className="bi bi-people me-2"></i>GX Clients
          </h3>
        </div>

        <div className="card border-0 shadow-sm mb-3">
          <div className="card-body">
            <div className="row g-2 align-items-end">
              <div className="col-md-5">
                <label className="form-label">Search</label>
                <input
                  className="form-control"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  placeholder="Name, diagnosis, region..."
                />
              </div>
              <div className="col-md-7 d-flex gap-2">
                <button className="btn btn-primary" onClick={() => fetchRows()}>Search</button>
                <button
                  className="btn btn-secondary"
                  onClick={() => {
                    setSearch("");
                    fetchRows({ search: "" });
                  }}
                >
                  Clear
                </button>
                <button className="btn btn-success" onClick={handleExcel}>Excel</button>
                <button className="btn btn-danger" onClick={handlePdf}>PDF</button>
              </div>
            </div>
          </div>
        </div>

        <div className="card border-0 shadow-sm">
          <div className="card-body">
            {loading ? (
              <div className="text-center py-4">
                <div className="spinner-border text-primary" role="status" />
              </div>
            ) : rows.length === 0 ? (
              <div className="text-center text-muted py-4">No GX clients found.</div>
            ) : (
              <div className="table-responsive">
                <table className="table table-bordered table-hover align-middle">
                  <thead style={{ backgroundColor: "#ece2ff" }}>
                    <tr>
                      <th>S.No</th>
                      <th>Date</th>
                      <th>Name</th>
                      <th>Diagnosis</th>
                      <th>Region</th>
                      <th>Session</th>
                    </tr>
                  </thead>
                  <tbody>
                    {rows.map((r, i) => (
                      <tr key={`${r.client_id}-${i}`}>
                        <td>{i + 1}</td>
                        <td>{r.record_date || "—"}</td>
                        <td>{r.name || "—"}</td>
                        <td>{r.diagnosis || "—"}</td>
                        <td>{r.region || "—"}</td>
                        <td>{r.session_recommended || "—"}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
